import { of, concat, from } from 'rxjs';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import {
  types,
  handleSubscriptionFormError,
  handleSubscriptionFormValid,
  handleSubscriptionFormSuccess,
} from './subscriptionForm.redux';
import { reset } from 'redux-form';
import * as R from 'ramda';
import { api, apiConfig } from 'components/api/api';

const subscriptionHandleFormEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.subscriptionHandleForm),
    debounceTime(1000),
    mergeMap(({ payload: { subscription } }) => {
      if (!R.isEmpty(subscription)) {
        return of(handleSubscriptionFormValid({ subscription }));
      } else if (!state$.value.subscriptionForm.message) {
        return of(handleSubscriptionFormError({ subscription, error: 'Invalid inputs' }));
      }
      return of();
    })
  );

const handleSubscriptionFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.handleSubscriptionFormSuccess),
    mergeMap(() => {
      return of(reset('subscriptionForm'));
    })
  );

const subscriptionHandleFormRegisterEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.handleSubscriptionFormRegister),
    mergeMap(({ payload: { subscriptionID, planId, typePaypal } }) => {
      if (!R.isEmpty(subscriptionID)) {
        return updateSuscription({
          subscriptionID,
          planId,
          typePaypal,
          userId: state$.value.subscriptionForm.user.id,
        })
          .then(() => handleSubscriptionFormSuccess())
          .catch(() =>
            handleSubscriptionFormError({
              subscription: {},
              error: `There was an error associating the subscription number ${subscriptionID} please save this number and contact us`,
            })
          );
      }
    })
  );

const updateSuscription = ({ userId, subscriptionID, planId, typePaypal }) => {
  return api.ajax('subscribeUser', {
    noWorker: true,
    url: apiConfig.appUrl,
    type: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      user: userId,
      subscription: subscriptionID,
      plan: planId,
      type: typePaypal,
    }),
  });
};

export default combineEpics(
  subscriptionHandleFormEpic,
  subscriptionHandleFormRegisterEpic,
  handleSubscriptionFormSuccessEpic
);
